// extracted by mini-css-extract-plugin
export default {"leftMenuMobile":"LeftMenu_leftMenuMobile__qK-lC","menuItem":"LeftMenu_menuItem__5T24p","menuBackground":"LeftMenu_menuBackground__jOWHW","menuTitle":"LeftMenu_menuTitle__GpSHS"};